import React from "react";
import HomeIcon from "../common/HomeIcon";
import { userDetailStore } from "../../config/store";
import { postData, translation } from "../../utils/helper";
import { imgUrl, imgBaseUrl, detailsPageBaseUrl } from "../../utils/url";
import { onSocialShareCT } from "../../utils/helper";
import $ from "jquery";
import SharePrintIcon from "../common/SharePrintIcon";
import Mantra6_3 from "./mantra6_3";
import DownloadBtnCommon from "../common/DownloadBtn";
import Loader from "../loader/loader";
import { showCongratulations } from "../../utils/misc";

class Mantra6_1 extends React.Component {

    constructor() {
        super();
        this.state = {
            body: "body body",
            subject: "subject",
            defaultemail:
                userDetailStore.getState().userDetail &&
                userDetailStore.getState().userDetail["user_email"],
            showThankYouPopUp: false,
            sendEmail: "",
            isLoading: false
        };
    }

    sendEmail = () => {

        this.setState({
            isLoading: true
        })
        if (this.email.value) {



            const { pageData, module_name } = this.props;
            let text = pageData.description ? pageData.description : "";
            let title = pageData.name ? pageData.name : "";
            title = pageData.inner_name ? pageData.inner_name : title;
            let template_url = pageData.template_url

            let detailurl = detailsPageBaseUrl;
            if (module_name) {
                detailurl += module_name;
            }

            // params["file"] = translation(
            //     "https://cdn.narendramodi.in/examwarriors/pdf/M6-ScoreCard-N.pdf",
            //     "image"
            // );
            var params = {};
            if (this.emailvalidate()) {
                params["email"] = this.email.value;
                // params["useremail"] = this.email.value;
                // params["file"] = imgBaseUrl + template_url;
                // params["body"] = text;
                // params["subject"] = title;
                // params["module_type"] = this.props.type; //module_type
                params["module_subtype"] = this.props.module_name; //sub module
                // params["message"] = text;
                // params['module_type'] = "img" //module_type
                // params['module_subtype'] = "m6" //sub module

                postData(params, "sendmail").done((data) => {
                    if (data._resultflag === "1") {
                        this.setState(
                            { showThankYouPopUp: true, isLoading: false, sendEmail: this.email.value },
                            () => {
                                // this.email.value = "";
                                onSocialShareCT({
                                    type: "mail",
                                    shareurl: detailurl,
                                    text: text,
                                    module: module_name ? module_name : ""
                                });

                                showCongratulations(this.props.module_name)
                            }
                        );
                    } else {
                        this.setState({
                            isLoading: false
                        })
                    }
                    // swal("Email has been sent to:  " + this.email.value + " Thank you.");
                    // postData(params, 'savedata', 'noloader');
                    // this.email.value = "";
                });
            }
            this.setState({
                isLoading: false
            })
        } else {
            this.setState({
                isLoading: false
            })
            alert('Please fill your email.');
        }
    };
    emailvalidate = () => {
        var filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        if (filter.test(this.email.value)) {
            var email = this.email.value;
            $(".send_email_button").find("img").removeClass("disabled");
            return true;
        } else {
            $(".send_email_button").find("img").addClass("disabled");
            //swal( "Invalid Email !" );
            return false;
        }
    };

    closeThankYouPopUp = () => {
        this.setState({
            showThankYouPopUp: false,
            sendEmail: "",
        });
    };

    render() {
        const {
            defaultemail,
            body,
            subject,
            showThankYouPopUp,
            sendEmail,
            isLoading
        } = this.state;
        const { pageData, module_name } = this.props;
        let image = pageData.template_url ? imgUrl + pageData.template_url : "";
        let text = pageData.description ? pageData.description : "";

        return (
            <div>
                {/* <Carousel /> */}

                {
                    isLoading && (
                        <Loader />
                    )
                }

                {showThankYouPopUp && (
                    <Mantra6_3
                        email={sendEmail}
                        closeThankYouPopUp={this.closeThankYouPopUp}
                    />
                )}

                {!showThankYouPopUp && (
                    <div className="mantr6_1">
                        <HomeIcon />
                        <div className="container">
                            <SharePrintIcon
                                pageData={this.props.pageData}
                                image={image}
                                text={text}
                                id={module_name}
                            />
                            {/* <div className="mantra_sharelist1">
                    <ul>
                        <li>
                            {<NativeShare
                                sharedata={{
                                    image,
                                    text
                                }}
                            >
                                <img src="/assets/img/share.png" className="img-fluid" alt="" />
                            </NativeShare>}
                        </li>
                        <li>
                            <img src="/assets/img/print.png" className="img-fluid" alt="" />
                        </li>
                    </ul>
                </div> */}

                            <div className="mantra_sharelist_brdr">
                                <img
                                    src="/assets/img/mantra_6_icon.png"
                                    className="mn6_ic"
                                    alt=""
                                />
                                <div className="mantra_sharelist">
                                    <img
                                        src={this.props.pageData.template_url}
                                        id="downloadImg"
                                        className="img-fluid mantra6_banner"
                                        alt=""
                                    />
                                    <div className="preview_btn preview_btn_postion">
                                        <DownloadBtnCommon pageData={this.props.pageData} module={module_name}>
                                            <button type="button" className="download">
                                                Download
                      </button>
                                        </DownloadBtnCommon>
                                        <p>Or</p>
                                        <button
                                            type="button"
                                            className="email"
                                            onClick={this.sendEmail}
                                        >
                                            Email
                    </button>
                                    </div>
                                </div>
                            </div>
                            <div className="email_div">
                                <p>
                                    <label>Your email *</label>
                                </p>
                                <input
                                    type="text"
                                    ref={(email) => {
                                        this.email = email;
                                    }}
                                    defaultValue={defaultemail}
                                    placeholder="Email"
                                />
                            </div>
                        </div>
                    </div>
                )}

                {/* <div className="mantr6_popup">
            <div className="mantr6_popupcontent">
            <img src="/assets/img/close.png" className="img-fluid cross_btn" alt="" />
                <h4>Share...</h4>
                <ul>
                    <li>
                        <a href="#">
                            <img src="/assets/img/facebook.png" className="img-fluid" alt="" /> Facebook
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <img src="/assets/img/twitter.png" className="img-fluid" alt="" /> Twitter
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <img src="/assets/img/instagram.png" className="img-fluid" alt="" /> Instagram
                        </a>
                    </li>
                </ul>
                <img src="/assets/img/img-15.png" className="img-fluid popup_img15" alt="" />
                <img src="/assets/img/img-14.png" className="img-fluid popup_img14" alt="" />
            </div>
        </div> */}
            </div>
        );
    }
}

export default Mantra6_1;
